import React, { useEffect, useState } from "react";
import { Email, Facebook, Instagram, LinkedIn, LocalPhone, Twitter, Menu, ArrowDropDown } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { email, phone_number } from "../config/details";
import { logo, title } from "../config/Config";
import Mode_logo from "../Assets/images/logo.png";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { Accordion,} from "react-bootstrap";


const Header = () => {
  const location = useLocation();


  //responsive sidebar modal states
  const [open2, setonOpenModal2] = useState(false);

  const onOpenModal2 = () => setonOpenModal2(true);
  const onCloseModal2 = () => setonOpenModal2(false);





  useEffect(() => {

    // this code contact page header work ..
    if (location.pathname === "/contact") {
      document.body.setAttribute("contact-attribute", "true");
    } else {
      document.body.removeAttribute("contact-attribute");
    }

    if (location.pathname === "/team") {
      document.body.setAttribute("team-attribute", "true");
    } else {
      document.body.removeAttribute("team-attribute");
    }

    if (location.pathname === "/blog") {
      document.body.setAttribute("blog-attribute", "true");
    } else {
      document.body.removeAttribute("blog-attribute");
    }

    if (location.pathname === "/services") {
      document.body.setAttribute("service-attribute", "true");
    } else {
      document.body.removeAttribute("service-attribute");
    }

    if (location.pathname === "/wordpress") {
      document.body.setAttribute("wordpress-attribute", "true");
    } else {
      document.body.removeAttribute("wordpress-attribute");
    }

    if (location.pathname === "/email-hosting") {
      document.body.setAttribute("emailhosting-attribute", "true");
    } else {
      document.body.removeAttribute("emailhosting-attribute");
    }

  }, [location.pathname]);

  useEffect(() => {
    const headerScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;

      if (scrollY >= 645) {
        document.body.setAttribute("header-attribute", "true");

      } else {
        document.body.removeAttribute("header-attribute");
      }
    };

    window.addEventListener("scroll", headerScroll);

    return () => {
      window.removeEventListener("scroll", headerScroll);
    };
  }, []);



  const HeaderData = [
    {
      LinkName: "Home",
      LinkUrl: '/',
      dropdown: null
    },
    {
      LinkName: "About",
      LinkUrl: '/about',
      dropdown: null
    },
    {
      LinkName: "Services",
      LinkUrl: '',
      dropdown: [
        {
          dropLinkName: "Website Designing",
          dropLinkUrl: '/web-design'
        },
        {
          dropLinkName: "Website Development",
          dropLinkUrl: '/webdeveloper'
        },

        {
          dropLinkName: "Wordpress Website Design",
          dropLinkUrl: '/wordpress'
        },

        {
          dropLinkName: "Search Engine Optimization",
          dropLinkUrl: '/search-engine'
        },

        {
          dropLinkName: "Web Hosting",
          dropLinkUrl: '/webhosting'
        },

        {
          dropLinkName: "Bulk SMS $ Email Hosting",
          dropLinkUrl: '/email-hosting'
        },

        // {
        //   dropLinkName: "Mobile Apps",
        //   dropLinkUrl: '/mobile-app'
        // },

      ],
    },
    {
      LinkName: "Blog",
      LinkUrl: '/blog',
      dropdown: null
    },
    {
      LinkName: "Portfolio",
      LinkUrl: '/portfolio',
      dropdown: null
    },
    {
      LinkName: "Contact us",
      LinkUrl: '/contact',
      dropdown: null
    },
  ];


  return (
    <>
      <div className="top-header">
        <div className="container-layout">
          {/* left top header section  */}

          <div className="left-t-header">
            <Link to={"mailto:" + email} target="_blank" className="link-t"> <Email /> <span> {email}</span> </Link>

            <Link to={"tel:" + phone_number} className="link-t"> <LocalPhone /> <span> {phone_number}</span> </Link>
          </div>

          {/* right top header section */}
          <div className="right-t-header">
            <Link to="#" className="social-medias" target="_blank"><Facebook /> </Link>
            <Link to="#" className="social-medias" target="_blank"><Twitter /> </Link>
            <Link to="#" className="social-medias" target="_blank"><Instagram /> </Link>
            <Link to="#" className="social-medias" target="_blank"> <LinkedIn /> </Link>
          </div>
        </div>
      </div>

      {/* header work start.... */}

      <header>
        <div className="container-layout">
          <div className="left-header">
            <Link to="/" className="navbar-logo">
              <img src={logo} alt={title + "logo"} />
              <img src={Mode_logo} className="mode-logo" alt={title + "logo"} />
            </Link>


            <button onClick={onOpenModal2} type="button" className="btn toggle-button"><Menu /></button>
          </div>

          <div className="right-header">
            <ul className="nav align-items-center">
              <li className={`${location.pathname === "/" && "footer_active_Link"} nav-item`}>
                <Link to="/" className="nav-link">Home</Link>
              </li>

              <li className={`${location.pathname === "/about" && "footer_active_Link"} nav-item`}>
                <Link to="/about" className="nav-link">About</Link>
              </li>

              <li className="nav-item">
                <Link to="/" className="nav-link">Services<ArrowDropDown className="arrow_icon_header" /></Link>
                <div className="sub_menu">
                  <ul>
                    <li className={`${location.pathname === "/web-design" && "footer_active_Link"} list`}><Link to="/web-design" className="site_link">Website Designing</Link></li>
                    <li className={`${location.pathname === "/webdeveloper" && "footer_active_Link"} list`}><Link to="/webdeveloper" className="site_link">Website Development</Link></li>
                    <li className={`${location.pathname === "/wordpress" && "footer_active_Link"} list`}><Link to="/wordpress" className="site_link">Wordpress Website Design</Link></li>
                    <li className={`${location.pathname === "/search-engine" && "footer_active_Link"} list`}><Link to="/search-engine" className="site_link">Search Engine Optimization</Link></li>
                    <li className={`${location.pathname === "/webhosting" && "footer_active_Link"} list`}><Link to="/webhosting" className="site_link">Web Hosting</Link></li>
                    <li className={`${location.pathname === "/email-hosting" && "footer_active_Link"} list`}><Link to="/email-hosting" className="site_link">Bulk SMS $ Email Hosting</Link></li>
                    {/* <li className={`${location.pathname === "/mobile-app" && "footer_active_Link"} list`}><Link to="/mobile-app" className="site_link">Mobile Apps</Link></li> */}
                  </ul>
                </div>
              </li>

              <li className={`${location.pathname === "/blog" && "footer_active_Link"} nav-item`}>
                <Link to="/blog" className="nav-link">Blog</Link>
              </li>

              <li className={`${location.pathname === "/portfolio" && "footer_active_Link"} nav-item`}>
                <Link to="/portfolio" className="nav-link">Portfolio</Link>
              </li>

              <li className={`${location.pathname === "/contact" && "footer_active_Link"} nav-item`}>
                <Link to="/contact" className="nav-link">Contact Us</Link>
              </li>

              {/* {HeaderData.map((item :any, index :any) => (


                <li className="nav-item" key={index}>
                  {item.dropdown == null && <Link to={item.LinkUrl} className="nav-link">{item.LinkName} </Link>}

                  {item.dropdown && (
                    <ul className="p-0">
                      <Dropdown>
                        <Dropdown.Toggle className="bg-transparent border-0 text-black nav-link" id="dropdown-basic">
                          {item.LinkName}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {item.dropdown.map((subItem :any) => (
                            <Link key={subItem.dropLinkName} className="dropdown-item" to={subItem.dropLinkUrl}>{subItem.dropLinkName} </Link>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </ul>
                  )}
                </li>
              ))} */}
            </ul>
          </div>
        </div>
      </header>





      <Modal open={open2} onClose={onCloseModal2}
        classNames={{
          modal: "new_modal_sidebar",
          modalAnimationIn: 'customEnterModalAnimation',
          modalAnimationOut: 'customLeaveModalAnimation',
        }}>
        <div className="phone-view-header">
          <p>More Services</p>
          <ul className="nav flex-column">
            <Accordion defaultActiveKey="0">
              {HeaderData.map((item: any, index: any) => (
                <li className="nav-item" key={index}>
                  {item.dropdown == null && (
                    <Link
                      to={item?.LinkUrl} 
                      className="nav-link"
                      onClick={onCloseModal2} // Close modal when link is clicked
                    >
                      {item.LinkName}
                    </Link>
                  )}
                  {item.dropdown && (
                    <ul className="p-0">
                      <Accordion.Item eventKey="">
                        <Accordion.Header>
                          {' '}
                          <span>{item.LinkName} </span>{' '}
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul className="p-0">
                            {item.dropdown.map((subItem: any) => (
                              <Link
                                className="nav-link nav_link_after"
                                key={subItem.dropLinkName}
                                to={subItem.dropLinkUrl}
                                onClick={onCloseModal2} // Close modal when link is clicked
                              >
                                {/* -  */}
                                {subItem.dropLinkName}
                              </Link>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </ul>
                  )}
                </li>
              ))}
            </Accordion>
          </ul>
        </div>
      </Modal>

    </>
  );
};

export default Header;
